import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "text-justify q-mt-md"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock(_component_s_modal, {
    modelValue: _ctx.dialogVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisibility) = $event)),
    title: _ctx.titleForm,
    size: "middle"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_s_btn, {
        class: "q-mr-md",
        label: "Закрыть",
        loading: _ctx.loading.state.value,
        onClick: _ctx.close
      }, null, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", { innerHTML: _ctx.safeContent }, null, 8, _hoisted_1),
        (_ctx.mailToLink || _ctx.mailToLinkHelpdesk)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createTextVNode(" Если вы уже отправили ")),
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "идентификатор блокировки (Reason of support ID)", -1)),
              _cache[3] || (_cache[3] = _createTextVNode(" на электронную почту (")),
              _createElementVNode("a", {
                target: "_blank",
                class: "s-link",
                href: _ctx.mailToLink
              }, _toDisplayString(_ctx.wafSupport), 9, _hoisted_3),
              _cache[4] || (_cache[4] = _createTextVNode("), но хотите ускорить решение проблемы, напишите в нашу ")),
              _createElementVNode("a", {
                class: "s-link",
                target: "_blank",
                href: _ctx.mailToLinkHelpdesk
              }, "службу поддержки (" + _toDisplayString(_ctx.helpdeskEmail) + ")", 9, _hoisted_4),
              _cache[5] || (_cache[5] = _createTextVNode(" и укажите тот же идентификатор блокировки. ")),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createTextVNode(" Мы постараемся помочь вам как можно быстрее! "))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}